import React from 'react';
import { withErrorBoundary } from '../components/error-handling';
const withLazy = ({ importFn, loader, errorHandling, }) => {
    var _a;
    const Component = React.lazy(importFn);
    const isSSR = typeof window === 'undefined';
    const renderLoader = (props) => {
        switch (loader === null || loader === void 0 ? void 0 : loader.type) {
            case 'COMPONENT':
                const Component = loader.component;
                return React.createElement(Component, Object.assign({}, props));
            case 'CHILDREN':
                return React.createElement(React.Fragment, null, props.children);
            default:
                return null;
        }
    };
    const WrappedComponent = (props) => {
        if (isSSR) {
            return renderLoader(props);
        }
        return (React.createElement(React.Suspense, { fallback: renderLoader(props) },
            React.createElement(Component, Object.assign({}, props))));
    };
    return errorHandling.type === 'PROPAGATE'
        ? WrappedComponent
        : withErrorBoundary(WrappedComponent, (_a = errorHandling.fallbackComponent) !== null && _a !== void 0 ? _a : (() => null));
};
export default withLazy;
//# sourceMappingURL=with-lazy.js.map